import {
	AGE_GATE_PRIVACY_HREF,
	AGE_GATE_TERMS_HREF,
} from '../constants/ageGate.constants';
import { AgeGateLegal } from '../AgeGate.styles';

const AgeGateLegalNotice = ({ translations }) => (
	<AgeGateLegal>
		{translations.legalPrefix}{' '}
		<a href={AGE_GATE_TERMS_HREF} target="_blank" rel="noopener noreferrer">
			{translations.termsOfService}
		</a>{' '}
		{translations.legalAnd}{' '}
		<a href={AGE_GATE_PRIVACY_HREF} target="_blank" rel="noopener noreferrer">
			{translations.privacyPolicy}
		</a>
		.
	</AgeGateLegal>
);

export default AgeGateLegalNotice;
